import { useRoutes } from "react-router-dom";

import AuthRoutes from "./authRoutes";

export default function AuthLayout() {
  return useRoutes([AuthRoutes]);
}
